import definition from './alerts.service';

/**
 * AlertsApi settings
 * @type {{name: string, definition: AlertsApi}}
 */
export default {
    name: 'AlertsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/alerts/index.js